import { useEffect } from 'react';
import SuppliersHero from './components/SuppliersHero';
import PartnerIntroSection from './components/PartnerIntroSection';
import SupplierApplicationForm from './components/SupplierApplicationForm';

const SUPPLIERS_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/suppliers#webpage`,
  url: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/suppliers`,
  name: 'Supplier Partners | MAX-Sourcing Global Chemical & Pharmaceutical Supply Network',
  description:
    'Join the MAX-Sourcing supplier network. We partner with cGMP-certified manufacturers of pharmaceutical APIs, fine chemicals, food ingredients, industrial and mining chemicals worldwide.',
  inLanguage: 'en',
  isPartOf: {
    '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#website`,
  },
  dateModified: '2026-04-07',
  about: {
    '@type': 'Organization',
    name: 'MAX-Sourcing',
    url: import.meta.env.VITE_SITE_URL ?? 'https://example.com',
  },
  translationOfWork: {
    '@type': 'WebPage',
    '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/fr/fournisseurs#webpage`,
    url: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/fr/fournisseurs`,
    inLanguage: 'fr',
  },
  workTranslation: {
    '@type': 'WebPage',
    '@id': `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/fr/fournisseurs#webpage`,
    url: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/fr/fournisseurs`,
    inLanguage: 'fr',
  },
};

export default function SuppliersPage() {
  useEffect(() => {
    document.title = 'Supplier Partners | MAX-Sourcing Global Chemical & Pharmaceutical Supply Network';
    const id = 'schema-suppliers';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(SUPPLIERS_SCHEMA);
    return () => {
      document.getElementById(id)?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <main className="flex-1">
        <SuppliersHero />
        <PartnerIntroSection />
        <SupplierApplicationForm />
      </main>
    </div>
  );
}
